import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import { CHILDREN_PROP_TYPES } from 'propTypes';
import {
  AppBarDivider,
  AppBarFulfillmentDeliveryAddress,
  AppBarFulfillmentMethodOptionLink,
  AppBarFulfillmentTime
} from 'components/AppBar';

import { toTitleCase } from 'bento-ordering/base/utils/textUtils';
import { ALL_FULFILLMENT_METHODS } from 'constants/fulfillmentOptions';

function AppBarFulfillmentOptions({
  children,
  deliveryAddress,
  fulfillmentMethod,
  fulfillmentOptions,
  fulfillmentTimeOrASAPDisplay,
  onClick,
  shouldDisableFulfillmentOptions = false
}) {
  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      flexDirection={{ xs: 'column', md: 'row' }}
      padding={{ xs: '10px 0', md: 'none' }}
      sx={{
        opacity: shouldDisableFulfillmentOptions ? 0.6 : 1
      }}
      data-testid="app-bar-fulfillment-options"
    >
      {fulfillmentOptions &&
        fulfillmentOptions.map(fulfillmentOption => {
          const isChosenMethod = fulfillmentMethod === fulfillmentOption;
          const fulfillmentOptionLabel = toTitleCase(fulfillmentOption);
          return (
            <AppBarFulfillmentMethodOptionLink
              key={fulfillmentOption}
              dataTestId={`${fulfillmentOption}-option`}
              id={`${fulfillmentOption}-option`}
              fulfillmentOptionIcon={fulfillmentOption}
              fulfillmentOptionLabel={fulfillmentOptionLabel}
              isActive={isChosenMethod}
              onClick={() => onClick(fulfillmentOption)}
              shouldDisableFulfillmentOptions={shouldDisableFulfillmentOptions}
            />
          );
        })}

      <AppBarDivider />

      {fulfillmentTimeOrASAPDisplay && (
        <AppBarFulfillmentTime
          fulfillmentTimeOrASAPDisplay={fulfillmentTimeOrASAPDisplay}
          onClick={() => onClick()}
          shouldDisableFulfillmentOptions={shouldDisableFulfillmentOptions}
        />
      )}

      {deliveryAddress && (
        <AppBarFulfillmentDeliveryAddress
          deliveryAddress={deliveryAddress}
          onClick={() => onClick()}
          shouldDisableFulfillmentOptions={shouldDisableFulfillmentOptions}
        />
      )}

      {children}
    </Box>
  );
}

AppBarFulfillmentOptions.propTypes = {
  children: CHILDREN_PROP_TYPES,
  deliveryAddress: PropTypes.string,
  fulfillmentMethod: PropTypes.string,
  fulfillmentOptions: PropTypes.arrayOf(
    PropTypes.oneOf(ALL_FULFILLMENT_METHODS)
  ),
  fulfillmentTimeOrASAPDisplay: PropTypes.string,
  onClick: PropTypes.func,
  shouldDisableFulfillmentOptions: PropTypes.bool
};

export default AppBarFulfillmentOptions;
